import type { IZoneListFilter } from '@/types/api';

/**
 * Serialize an `IZoneListFilter` into a `URLSearchParams` for use with
 * `setSearchParams`. The inverse of `buildFilterFromParams` in
 * `ZoneManagementPage`. Pagination defaults (`page=1`, `limit=10`) are
 * omitted so the URL stays clean for the empty/default state. `page` is
 * written only when it is greater than 1 — page 1 is the default and stays
 * out of the URL. There is no `status` axis — hunting zones carry no SpotOn
 * workflow status.
 *
 * Note: the URL keys for names, countries and owners are `name` /
 * `country` / `owner_id` (singular) — the array shape is encoded as repeated
 * keys.
 * This matches the existing reader in `ZoneManagementPage` and the API's
 * own parameter names.
 */
export function serializeFilterToParams(filter: IZoneListFilter): URLSearchParams {
  const params = new URLSearchParams();
  if (filter.names) {
    for (const n of filter.names) params.append('name', n);
  }
  if (filter.countries) {
    for (const c of filter.countries) params.append('country', c);
  }
  if (filter.owner_ids) {
    for (const id of filter.owner_ids) params.append('owner_id', id);
  }
  if (filter.page && filter.page > 1) params.set('page', String(filter.page));
  return params;
}
